import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://mgzyaqvsahsaifhshmis.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1nenlhcXZzYWhzYWlmaHNobWlzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5Mjk3MDUsImV4cCI6MjA4OTUwNTcwNX0.Kf2l9sM2oirabAvTnvDh_SzoeIipRHk6FF-EP5_qoOg'

export const supabase = createClient(supabaseUrl, supabaseKey)

// The service-role client was REMOVED from the frontend (2026-06 security
// hardening). It embedded the service-role key in the browser bundle, which
// bypasses RLS — anyone extracting it had god-mode on the database. All the
// privileged work it used to do now runs server-side:
//   - auth.admin.* user lifecycle + privileged deletes → /api/admin/users
//     (admin-gated; see src/lib/adminApi.js)
//   - storage uploads/removes → the authenticated client, backed by the
//     storage RLS policies in db/migrations/2026-06-storage-authenticated-policies.sql
// The server-only SUPABASE_SERVICE_KEY lives in the Vercel env for /api use.
// Do NOT reintroduce a service-role client here.
